export default function() {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect x="3.5" y="12.5" width="5" height="9" rx="1.5" stroke="#D7D9DB" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="8.5" y="1.5" width="6" height="20" rx="1.5" stroke="#D7D9DB" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="14.5" y="5.5" width="5" height="16" rx="1.5" stroke="#D7D9DB" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}